import _ from 'lodash'
import {populateClub, saveClub, saveNewClub, doCsvUploadForClub} from '../api'

export const loadClub = ({ state, commit }, {uuid, loadDataFromServer}) => {
  if (loadDataFromServer || _.isEmpty(state.club)) {
    return populateClub(uuid).then((response) => {
      commit('LOAD_CLUB', response)
      return response
    })
  } else {
    commit('LOAD_CLUB', state.club)
    return state.club
  }
}

export const storeClub = ({ state, commit }, clubObj) => {
  if (!clubObj.uuid) {
    return saveNewClub(clubObj).then((response) => {
      commit('LOAD_CLUB', response)
      return response
    })
  }
  return saveClub(clubObj).then((response) => {
    commit('LOAD_CLUB', response)
    return response
  })
}

export const uploadClubCsvFile = ({ state, commit }, {institutionId, createdByUuid, folderId, fileData}) => {
  return doCsvUploadForClub(institutionId, createdByUuid, folderId, fileData).then(res => {
    return res
  })
}



// WEBPACK FOOTER //
// ./src/app/club/vuex/actions.js